import React, { useEffect, useState } from "react";
import GLEqpSummaryTable from "./GlEqpSummaryTable1";

function GlDomesticWaterPumpSummargPage() {
  let imageParamsEqp = [
    { title: "VRF Run Status", parameter1: "VRF_RUN_SS", unit: "" },
    { title: "VRF ON/OFF", parameter1: "VRF_On_Off_Cmmd", unit: "" },
    { title: "VRF Auto/Manual", parameter1: "VRF_AM_SS", unit: "" },
    // {title: 'Chiller Mode',parameter1: 'CH_AM_SS',unit:''},
    // {title: 'Run Status',parameter1: 'CH_Run_SS',unit:''},
    // {title: 'Trip Status',parameter1: 'CH_Trip_SS_Alarm',unit:''},
    // {title: 'Chiller Motorized Valve',parameter1: 'CH_Out_Vlv_SS',unit:''},
    // {title: 'Compressor Load 1',parameter1: 'Comp_Load_1',unit:''},
    // {title: 'Compressor Load 2',parameter1: 'Comp_Load_2',unit:''},
    // {title: 'Compressor Power 1',parameter1: 'Comp_Power_1',unit:''},
    // {title: 'Compressor Power 2',parameter1: 'Comp_Power_2',unit:''},
    // {title: 'Oil Pressure 1[PSIG]',parameter1: 'Oil_Pre_1',unit:''},
    // {title: 'Oil Pressure 2[PSIG]',parameter1: 'Oil_Pre_2',unit:''},
    // {title: 'Oil Temperature 1[℃]',parameter1: 'Oil_Temp_1',unit:''},
    // {title: 'Oil Temperature 2[℃]',parameter1: 'Oil_Temp_2',unit:''},
    // {title: 'Suction Pressure 1[PSIG]',parameter1: 'Suc_Pre_1',unit:''},
    // {title: 'Suction Pressure 2[PSIG]',parameter1: 'Suc_Pre_2',unit:''},
    // {title: 'Discharge Pressure 1[PSIG]',parameter1: 'Dis_Pre_1',unit:''},
    // {title: 'Discharge Pressure 2[PSIG]',parameter1: 'Dis_Pre_2',unit:''},
    // {title: 'Discharge Temperature 1[℃]',parameter1: 'Dis_Temp_1',unit:''},
    // {title: 'Discharge Temperature 2[℃]',parameter1: 'Dis_Temp_2',unit:''},
  ];

  const ss_types = ["NONGL_SS_VRF"];
  return (
    <>
      <GLEqpSummaryTable
        eqpSSTypes={ss_types}
        imageParamsEqp={imageParamsEqp}
      />
    </>
  );
}

export default GlDomesticWaterPumpSummargPage;
